import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateMask]',
  standalone: true,
})
export class DateMaskDirective {
  constructor(private formControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const input = event.target;
    const value = input.value.replace(/\D/g, ''); // Remove non-numeric characters
    const formattedValue = this.formatDate(value);
    const cursorPosition = input.selectionStart;

    this.formControl?.control?.setValue(formattedValue);

    if (cursorPosition === 2 || cursorPosition === 5) {
      input.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
    } else {
      // Restore cursor position after formatting
      input.setSelectionRange(cursorPosition, cursorPosition);
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const key = event.key;

    // Allow backspace key to delete characters before the slash
    if (key === 'Backspace') {
      const cursorPosition = input.selectionStart;

      if (cursorPosition === 3 || cursorPosition === 6) {
        event.preventDefault();
        const value = input.value;
        const newValue =
          value.substring(0, cursorPosition - 1) +
          value.substring(cursorPosition);
        input.value = newValue;
        input.setSelectionRange(cursorPosition - 1, cursorPosition - 1);
        this.formControl?.control?.setValue(newValue, { emitEvent: false });
      }
    }
  }

  formatDate(value: string): string {
    const day = value.substring(0, 2);
    const month = value.substring(2, 4);
    const year = value.substring(4, 8);

    let formattedDate = '';

    if (day) {
      formattedDate += day;
      if (day.length === 2) {
        formattedDate += '/';
      }
    }

    if (month) {
      formattedDate += month;
      if (month.length === 2) {
        formattedDate += '/';
      }
    }

    if (year) {
      formattedDate += year;
    }

    return formattedDate;
  }
}
